import { nanoid } from 'nanoid';

//TODO write unit tests once CRA 3.5 is released and test config is fixed
export const generateNewId = () => nanoid();